// Types
import type { UserComponentsAction } from '@jet-app/music-classical/action-model/UserComponentsAction';
import type { Jet } from '~/jet';
import type { LoggerFactory } from '@amp/web-apps-logger';

// Utils for Intents
import { makeUserComponentsIntent } from '@jet-app/music-classical/intents/user-components/UserComponentsIntent';
import { setLibraryStates } from '~/stores/local-library-state';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
};

export function registerHandler(dependencies: Dependencies) {
    const { jet, logger } = dependencies;

    const log = logger.loggerFor('jet/action-handlers/user-components-action');

    jet.onAction(
        'userComponentsAction',
        async (action: UserComponentsAction) => {
            log.info('received UserComponentsAction:', action);

            try {
                const apiAction = makeUserComponentsIntent({
                    url: action.url,
                    actionType: action?.actionType,
                    payload: action?.payload,
                });

                const response = await jet.dispatch(apiAction);

                setLibraryStates(response?.entities);

                return 'performed';
            } catch (e) {
                log.error('User Components Action Error:', e);
                throw new Error(
                    'an error occurred while handling UserComponentsAction',
                );
            }
        },
    );
}
